const router = {
    //系统设置router
    path: 'dataCenter',
    name: 'dataCenter',
    component: resolve => require(['../../views/dataCenter/index.vue'], resolve),
    meta: {
        requireAuth: true,
        keepAlive: false,
        title: '数据统计',
        level: 1
    },
    children: []
}

export default router



// WEBPACK FOOTER //
// ./src/router/module/dataCenter.js